import { TraceType } from '../../common/enums/TraceType';
import { Slot } from './Slot';

export class Report {
  constructor(
    private readonly uuid: string,
    private readonly id: number,
    private readonly name: string,
    private readonly traceType: TraceType | null,
    private readonly slot: Slot | null
  ) {}

  getUUID() {
    return this.uuid;
  }

  getId() {
    return this.id;
  }

  getLabel() {
    return this.name;
  }

  getTraceType() {
    return this.traceType;
  }

  getSlot() {
    return this.slot;
  }

  toRawJson() {
    return {
      id: this.uuid,
      name: this.name,
      traceType: this.traceType,
      slot: this.slot?.toRawJson() || null,
    };
  }
}
